module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-card', {
    staticClass: "contact toggle-card md-elevation-1",
    attrs: {
      "md-theme": "white"
    }
  }, [_c('md-card-content', [_c('div', {
    staticClass: "heading",
    on: {
      "click": _vm.toggleVisible
    }
  }, [(_vm.visible) ? _c('md-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canToggle),
      expression: "canToggle"
    }],
    staticClass: "arrow"
  }, [_vm._v("keyboard_arrow_down ")]) : _vm._e(), (!_vm.visible) ? _c('md-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canToggle),
      expression: "canToggle"
    }],
    staticClass: "arrow"
  }, [_vm._v("keyboard_arrow_right")]) : _vm._e(), _c('div', {
    staticClass: "md-subheading",
    domProps: {
      "innerHTML": _vm._s(_vm.heading)
    }
  }), _vm._t("actions"), (_vm.canDelete) ? _c('md-button', {
    staticClass: "small md-icon-button md-dense",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.$emit('delete')
      }
    }
  }, [_c('md-icon', [_vm._v("clear")])], 1) : _vm._e()], 2), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "content"
  }, [_vm._t("default")], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e8c71f74","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ToggleCard.vue
// module id = 1271
// module chunks = 0